module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Right.caac19c2.svg";